
import { sprintf } from "sprintf-js";

const create_csv_blob = (trade_orders, tda_account_number) => {

  let csv = "";
  let op, cols;

  Object.keys(trade_orders).forEach(sym => {
    if (sym !== "CASH") {
      const order = trade_orders[sym]

      if (order.op === "BUY") {
        op = "B";
      } else if (order.op === "SELL") {
        op = "S";
      } else {
        console.log("Unknown operator", order.op);
      }

      cols = [
        tda_account_number,
        op,
        sprintf("%d", order.size),
        sym,
        "M",
      ];
      csv += cols.join(",") + "\n";
    }
  });
  return new Blob([csv], { type: 'text/plain'});
}

export { create_csv_blob };
